import baseTheme from '../theme';

export default {
  useLocalStorage: false,
  ...baseTheme,
};
